module.exports = __webpack_public_path__ + "assets/media/level5-user-icon.53636150.png";